<script setup lang="ts">
  import { useAuthStore } from '~/stores/useAuthStore'
  import { isMobile, init } from '~/helpers/breakpoints'

  const store = useAuthStore()

  const openDashBoard = ref(true)

  const dashBoardWidth = computed(() => (!openDashBoard.value ? 67 : 290))
  const contentWidthStyle = computed(() =>
    !isMobile.value ? `width: calc(100% - ${dashBoardWidth.value}px)` : '100%'
  )

  const appConfig = useAppConfig()

  onMounted(() => {
    const savedColor = localStorage.getItem('primaryColor')
    const savedThemeColor = localStorage.getItem('themeColor')

    if (savedColor || savedThemeColor) {
      appConfig.ui.colors.primary = savedColor ?? 'blue'
      appConfig.ui.colors.neutral = savedThemeColor ?? 'gray'
    }

    const token = localStorage.getItem('token')
    if (token) {
      store.getCurrentUser()
    }

    init()
  })
</script>

<template>
  <div class="fixed top-0 right-0 bottom-0 left-0 flex flex-row">
    <LeftMenu
      :open-dash-board="openDashBoard"
      @toggle="openDashBoard = $event"
    />

    <div
      class="flex w-full flex-col gap-2 bg-gray-100 dark:bg-zinc-800"
      :style="contentWidthStyle"
    >
      <NuxtPage class="p-5" />
    </div>
  </div>
</template>

<style scoped></style>
